import { useEffect, useState } from 'react'
import { Cookies } from 'react-cookie-consent'

const GA_ID = 'G-KD7GT5BVCQ'

const loadAnalytics = (path: string) => {
  if (typeof window === 'undefined') return

  const w = window as any
  if (document.getElementById('ga4-script')) {
    if (w.gtag && w.__gaLastPath !== path) {
      w.gtag('event', 'page_view', { page_path: path })
      w.__gaLastPath = path
    }
    return
  }

  const script = document.createElement('script')
  script.id = 'ga4-script'
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  script.async = true
  document.head.appendChild(script)

  w.dataLayer = w.dataLayer || []
  w.gtag = function gtag() {
    w.dataLayer.push(arguments)
  }
  w.gtag('js', new Date())
  w.gtag('config', GA_ID, { page_path: path })
  w.__gaLastPath = path
}

const useCookieConsent = (path: string) => {
  const [showConsentBanner, setShowConsentBanner] = useState(false)

  useEffect(() => {
    const consent = Cookies.get('gatsby-gdpr-google-tagmanager')
    setShowConsentBanner(!consent)
    if (consent === 'true') loadAnalytics(path)
  }, [path])

  const handleDecline = () => {
    Cookies.set('gatsby-gdpr-google-tagmanager', 'false', { expires: 365 })
    setShowConsentBanner(false)
  }

  const handleAccept = () => {
    Cookies.set('gatsby-gdpr-google-tagmanager', 'true', { expires: 365 })
    setShowConsentBanner(false)
    loadAnalytics(path)
  }

  return {
    showConsentBanner,
    handleAccept,
    handleDecline,
  }
}

export default useCookieConsent
